import { faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { IRecommendationGroup } from './recommendation.data';
import './Recommendations.scss';

interface IRecommendationsProperties {
    recommendationGroups: IRecommendationGroup[];
}

export function Recommendations(props: IRecommendationsProperties) {
    return (
        <motion.div
            initial={{
                y: 50,
                opacity: 0,
            }}
            whileInView={{
                y: 0,
                opacity: 1,
                transition: {
                    duration: 1,
                    type: "spring",
                    stiffness: 50
                }
            }}
            viewport={{
                once: true,
            }}
            className="page-content">
            <div className="page-name" data-title="Testimonials">Testimonials</div>
            <div className="recommendation-slider-holder my-3">
                <div className="recommendation-slider-wrapper">
                    <div className="recommendation-slider">
                        {props.recommendationGroups.map((recommendationGroup, recommendationGroupIndex) => (
                            <div key={"recommendation-group-" + recommendationGroupIndex}
                                className="recommendation-group"
                                style={{
                                    gridTemplateColumns: recommendationGroup.gridColumnSizes.join(" "),
                                    // gridTemplateRows: recommendationGroup.gridRowSizes.join(" "),
                                }}>
                                {recommendationGroup.recommendationData.map(recommendation => (
                                    <motion.div
                                        initial={{
                                            y: 50,
                                            opacity: 0,
                                        }}
                                        whileInView={{
                                            y: 0,
                                            opacity: 1,
                                            transition: {
                                                duration: 1,
                                                type: "spring",
                                                stiffness: 50
                                            }
                                        }}
                                        viewport={{
                                            once: true,
                                        }}

                                        whileHover={{
                                            scale: 1.05,
                                        }}
                                        
                                        className="recommendation-slider-item"
                                        key={"recommendation-" + recommendation.name}
                                        itemScope itemType="https://schema.org/EndorsementRating"
                                        style={{
                                            gridArea: recommendation.gridArea.join(" / "),
                                        }}>
                                        <div className="recommendation-slider-item-person" itemProp="author" itemScope itemType="https://schema.org/Person">
                                            <meta itemProp="url" content={recommendation.url}></meta>
                                            <meta itemProp="name" content={recommendation.name}></meta>
                                            <a className="recommendation-slider-item-person-photo-holder" href={recommendation.url} rel="noreferrer" target="_blank">
                                                <img itemProp="image" src={recommendation.photo} alt={recommendation.name} />
                                            </a>
                                            <a className="recommendation-slider-item-name" href={recommendation.url} rel="noreferrer" target="_blank">{recommendation.name}</a>
                                            <div className="recommendation-slider-item-title-company">
                                                <span className="recommendation-slider-item-title" itemProp="jobTitle">
                                                    {recommendation.title}
                                                </span>, <span className="recommendation-slider-item-company" itemProp="affiliation" itemScope itemType="https://schema.org/Organization">
                                                    <span itemProp="name">{recommendation.company}</span>
                                                </span>
                                            </div>
                                            {
                                                recommendation.quotePosition === "in-heading" &&
                                                <div className="recommendation-slider-item-quote">
                                                    <FontAwesomeIcon icon={faQuoteRight} />
                                                </div>
                                            }
                                        </div>
                                        <div className="hr" />
                                        {
                                            recommendation.quotePosition === "above-text" &&
                                            <div className="recommendation-slider-item-quote-above-text">
                                                <FontAwesomeIcon icon={faQuoteRight} />
                                            </div>
                                        }
                                        <div className="recommendation-slider-item-text" itemProp="ratingExplanation"
                                            dangerouslySetInnerHTML={{ __html: recommendation.text }} style={{
                                                lineHeight: recommendation.textLineHeight,
                                            }}></div>
                                    </motion.div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </motion.div>
    );
}
